// src/app/core/interceptors/company-header.interceptor.ts
import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import {CompanyService} from "../services/company.service";

@Injectable()
export class CompanyHeaderInterceptor implements HttpInterceptor {
  constructor(private companyService: CompanyService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Only target backend API base URL
    if (!req.url.startsWith(environment.baseBackendUrl)) {
      return next.handle(req);
    }

    // Do not override if already present
    if (req.headers.has('x-company-id')) {
      return next.handle(req);
    }

    // Read current selected company from BehaviorSubject
    const company = this.companyService.selectedCompany$.value;
    const companyId = company?.id; // tolerate casing

    // If no company selected, pass through
    if (!companyId) {
      return next.handle(req);
    }

    // Clone request with header
    const authReq = req.clone({
      setHeaders: { 'x-company-id': String(companyId) }
    });

    return next.handle(authReq);
  }
}
